import { CompanyPreset } from '../model/preset/company-preset';
import { CompanyPresetEventTypeEnum } from '../enum/company-preset-event-type.enum';

export class CompanyPresetEvent {
  public type: CompanyPresetEventTypeEnum;
  public value: CompanyPreset | null;

  constructor(type: CompanyPresetEventTypeEnum, value: CompanyPreset = null) {
    this.type = type;
    this.value = value;
  }
}
